import React, { Component } from "react";
import FoodItem from "./FoodItem";
import newfood from "../images/newfood.svg";
import SortableList, { SortableItem } from "react-easy-sort";

export default class Group extends Component {
  constructor(props) {
    super(props);
    this.state = {
      createNew: false,
      title: "",
      name: "",
      editId: "",
    };

    this.ref = React.createRef();
  }

  componentDidMount() {
    this.updateTitle();
  }

  updateTitle() {
    let title = "";
    let name = "";
    this.props.nameObj.forEach((element) => {
      if (
        element.languageId === this.props.selectedLangId &&
        (element.name !== "" ||
          element.name !== null ||
          element.name !== undefined)
      ) {
        title = element.name;
        name = element.name;
      }
    });

    if (title === "") {
      this.props.nameObj.forEach((element) => {
        if (
          element.languageId === this.props.defaultLangId &&
          (element.name !== "" ||
            element.name !== null ||
            element.name !== undefined)
        ) {
          title = element.name;
        }
      });
    }

    if (title === "") {
      this.props.nameObj.forEach((element) => {
        if (
          (element.name !== "" ||
            element.name !== null ||
            element.name !== undefined) &&
          title === ""
        ) {
          title = element.name;
        }
      });
    }

    this.setState({ title: title, name: name });
  }

  componentDidUpdate(prvProps) {
    if (
      prvProps.selectedLangId !== this.props.selectedLangId ||
      prvProps.nameObj !== this.props.nameObj
    ) {
      this.updateTitle();
    }
    if (
      prvProps.groupEditId !== this.props.groupEditId &&
      this.props.groupEditId !== this.state.editId
    ) {
      this.setState({ editId: this.props.groupEditId });
      if (this.props.groupEditId.toString().startsWith("createNew")) {
        if (
          this.props.groupEditId.toString().substring(9) !==
          this.props.catId.toString()
        ) {
          this.setState({ createNew: false });
        }
      } else {
        this.setState({ createNew: false });
      }
    }
  }

  onCreateNew() {
    this.setState({ createNew: true, editId: "" });
    this.props.onGroupEditMode("createNew" + this.props.catId);
  }

  onSubmit(api, data) {
    this.props.onSubmit(api, data);
    this.setState({ createNew: false, editId: "" });
  }

  onCancel() {
    this.setState({ createNew: false, editId: "" });
    this.props.onGroupEditMode("");
  }

  onDragEnd(oldIndex, newIndex) {
    this.props.onChangePriority(this.props.catId, oldIndex, newIndex);
  }

  onDeleteFood(menu) {
    this.props.onDeleteFood(menu);
  }

  onUpdateFood(menu) {
    this.props.onUpdateFood(menu);
  }

  onDuplicateFood(menu) {
    this.props.onDuplicateFood(menu);
  }

  onSortEnd(e) {
    console.log(e);
  }

  onEditMode(id) {
    this.setState({ editId: id, createNew: false });
    this.props.onGroupEditMode(id);
  }

  render() {
    return (
      <div className="container mt-5 pt-5">
        <div className="TitleCat">{this.state.title}</div>
        <SortableList
          onSortEnd={this.onDragEnd.bind(this)}
          className="fiListContainer"
          draggedItemClassName="fiObjectItemDrag"
        >
          {this.props.foods !== undefined &&
            this.props.foods !== null &&
            this.props.foods.length > 0 &&
            this.props.foods.map((item, i) => {
              if (this.state.editId !== item.id) {
                return (
                  <SortableItem key={i}>
                    <div>
                      <FoodItem
                        OPWarning={item.OPWarning}
                        rtlClass={this.props.rtlClass}
                        currentLang={this.props.currentLang}
                        catId={this.props.catId}
                        editId={this.state.editId}
                        onEditMode={this.onEditMode.bind(this)}
                        defaultLangId={this.props.default}
                        selectedLangId={this.props.selectedLangId}
                        nameObj={item.nameObj}
                        descrObj={item.descrObj}
                        businessId={this.props.businessId}
                        businessCode={this.props.businessCode}
                        id={item.id}
                        foodsLength={this.props.foods.length}
                        title={item.name}
                        description={item.descr}
                        price={item.price}
                        unit={this.props.unit}
                        img1={item.foodPicS1}
                        img2={item.foodPicS2}
                        img3={item.foodPicS3}
                        onSubmit={this.onSubmit.bind(this)}
                        isEnable={item.isEnable}
                        priority={item.priority}
                        onDeleteFood={this.onDeleteFood.bind(this)}
                        onUpdateFood={this.onUpdateFood.bind(this)}
                        onDuplicateFood={this.onDuplicateFood.bind(this)}
                        onCancel={this.onCancel.bind(this)}
                      />
                    </div>
                  </SortableItem>
                );
              } else {
                return (
                  <FoodItem
                    OPWarning={item.OPWarning}
                    rtlClass={this.props.rtlClass}
                    currentLang={this.props.currentLang}
                    key={i}
                    catId={this.props.catId}
                    editId={this.state.editId}
                    onEditMode={this.onEditMode.bind(this)}
                    defaultLangId={this.props.default}
                    selectedLangId={this.props.selectedLangId}
                    nameObj={item.nameObj}
                    descrObj={item.descrObj}
                    businessId={this.props.businessId}
                    businessCode={this.props.businessCode}
                    id={item.id}
                    foodsLength={this.props.foods.length}
                    title={item.name}
                    description={item.descr}
                    price={item.price}
                    unit={this.props.unit}
                    img1={item.foodPicS1}
                    img2={item.foodPicS2}
                    img3={item.foodPicS3}
                    onSubmit={this.onSubmit.bind(this)}
                    isEnable={item.isEnable}
                    priority={item.priority}
                    onDeleteFood={this.onDeleteFood.bind(this)}
                    onUpdateFood={this.onUpdateFood.bind(this)}
                    onDuplicateFood={this.onDuplicateFood.bind(this)}
                    onCancel={this.onCancel.bind(this)}
                  />
                );
              }
            })}
          {!this.state.createNew && (
            <div
              className="createNewFood"
              onClick={this.onCreateNew.bind(this)}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <img
                  src={newfood}
                  alt=""
                  style={{
                    objectFit: "cover",
                    width: "65px",
                    marginBottom: "10px",
                  }}
                />
                محصول جدید
              </div>
            </div>
          )}

          {this.state.createNew && (
            <FoodItem
              rtlClass={this.props.rtlClass}
              currentLang={this.props.currentLang}
              businessId={this.props.businessId}
              businessCode={this.props.businessCode}
              createNew={this.state.createNew}
              defaultLangId={this.props.default}
              selectedLangId={this.props.selectedLangId}
              catId={this.props.catId}
              foodsLength={
                this.props.foods !== undefined && this.props.foods !== null
                  ? this.props.foods.length
                  : 0
              }
              title=""
              description=""
              disable={false}
              onSubmit={this.onSubmit.bind(this)}
              onCancel={this.onCancel.bind(this)}
            />
          )}
        </SortableList>
      </div>
    );
  }
}
